import { serialiseMapBounds, type MapBounds } from 'lib/maps/bounds'
import type { TripPlannerSurfaceActivityEntry } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityEntryTypes'
import { boundActivityDisplayText } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityDisplayText'

export function buildMapSearchThisAreaActivityEntry(categoryLabel: string, bounds: MapBounds): TripPlannerSurfaceActivityEntry {
  return {
    kind: 'map_search_this_area',
    label: 'Searched map area',
    displayText: boundActivityDisplayText(`Searched area south,west,north,east=${serialiseMapBounds(bounds)} for "${categoryLabel}"`),
    sourcePath: 'trip_planner.map.search_this_area',
    dataClassification: 'personalised_surface',
    occurredAt: new Date().toISOString(),
  }
}
